import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { ApplicationInfoComponent } from '@ncs/ncs-lib';

import { SignupInvitationComponent } from './signup-invitation/signup-invitation.component';
import { InvitationMemberComponent } from './invitation-member/invitation-member.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { UiformEditComponent } from './components/uiform/uiform-edit/uiform-edit.component';
import { UiformListComponent } from './components/uiform/uiform-list/uiform-list.component';
import { UiformGraphComponent } from './components/uiform/uiform-graph/uiform-graph.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { MyProfileComponent } from './my-profile/my-profile.component';
import { CustomChartComponent } from './custom-chart/custom-chart.component';
import { UsecaseHelpComponent } from './usecase-help/usecase-help.component';
import { UiformViewComponent } from './components/uiform/uiform-view/uiform-view.component';
import { ImageCropperComponent } from './image-cropper/image-cropper.component';
import { UiformPivotComponent } from './components/uiform/uiform-pivot/uiform-pivot.component';
import { TasksListComponent } from './tasks-list/tasks-list.component';
import { UiformBaseComponent } from './components/uiform/uiform-base/uiform-base.component';
import { ReportsListComponent } from './reports-list/reports-list.component';
import { SignupComponent } from './common/signup/signup.component';
import { SupportTicketComponent } from './support-ticket/support-ticket.component';
import { AiReportComponent } from './components/uiform/ai-report/ai-report.component';
import { ApplicationDashboardComponent } from './application-dashboard/application-dashboard.component';
import { MenuListComponent } from './menu-list/menu-list.component';
import { ApplicationUsersComponent } from './application-users/application-users.component';
import { AssetReportComponent } from './asset-report/asset-report.component';
import { UploadLogsComponent } from './upload-logs/upload-logs.component';
import { ChatComponent } from './chat/chat.component';
const routes: Routes = [
  {
    path: 'invite/:token',
    component: InvitationMemberComponent,
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'login/:authKey',
    component: LoginComponent,
  },
  {
    path: 'appinfo',
    component: ApplicationInfoComponent,
  },
  {
    path: 'signup',
    component: SignupComponent,
  },
  {
    path: 'signupInvitation/:accessKey',
    component: SignupInvitationComponent,
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
  },
  {
    path: 'uiform/:uiformId',
    component: UiformEditComponent,
  },
  {
    path: 'uiform/:uiformId/:id',
    component: UiformEditComponent,
  },
  {
    path: 'uiformlist/:uiformId',
    component: UiformListComponent,
  },
  {
    path: 'uiformlist/:uiformId/:id',
    component: UiformListComponent,
  },
  {
    path: 'uiforminfo/:uiformId',
    component: UiformBaseComponent,
  },
  {
    path: 'uiformchart/:uiformId',
    component: UiformGraphComponent,
  },
  {
    path: 'uiformchartcustom/:formId',
    component: UiformGraphComponent,
  },
  {
    path: 'forgotpassword',
    component: ForgotPasswordComponent,
  },
  {
    path: 'myProfile',
    component: MyProfileComponent,
  },
  {
    path: 'customChart/:uiformId',
    component: CustomChartComponent,
  },
  {
    path: 'usecaseHelp/:uiformId',
    component: UsecaseHelpComponent,
  },
  {
    path: 'uiformview/:uiformId/:id',
    component: UiformViewComponent,
  },
  {
    path: 'uiformpivot/:uiformId',
    component: UiformPivotComponent,
  },
  {
    path: 'taskslist',
    component: TasksListComponent,
  },
  {
    path: 'image',
    component: ImageCropperComponent,
  },
  {
    path: 'reportslist/:reportId',
    component: ReportsListComponent,
  },
  {
    path: 'reportslist/:appId/:reportId',
    component: ReportsListComponent,
  },
  {
    path: 'support',
    component: SupportTicketComponent,
  },
  {
    path: 'signup/:authKey',
    component: SignupComponent,
  },
  {
    path: 'applicationdashboard',
    component: ApplicationDashboardComponent,
  },
  {
    path: 'menuslist',
    component: MenuListComponent,
  },
  {
    path: 'menuslist/:appId',
    component: MenuListComponent,
  },
  {
    path: 'applicationUser/:id',
    component: ApplicationUsersComponent,
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'aireport/:id',
    component: AiReportComponent,
  },
{
    path: 'assetReport',
    component: AssetReportComponent,
  },
  {
    path: 'upload-logs/:usecaseId',
    component: UploadLogsComponent,
  },
  {
    path: 'upload-logs/:usecaseId/:uploadId',
    component: UploadLogsComponent,
  },
  { path: 'chat', component: ChatComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy }],
  exports: [RouterModule],
})
export class AppRoutingModule {}
